import ListSubheader from '@material-ui/core/ListSubheader';
import List from '@material-ui/core/List';
import React, { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useLocales from '../../hooks/useLocales';
import { Roles } from '../../constants/roles.enum';
import SidebarItem from '../../layouts/dashboard/SidebarItem';
import useAuth from '../../hooks/useAuth';
import { RootState } from '../../redux/store';

type TNav = {
  subheader: string;
  items: TNavItem[];
};

type TNavItem = {
  icon?: ReactNode;
  info?: ReactNode;
  href: string;
  title: string;
  role?: string | string[];
  feature?: string | undefined;
};

type RenderSidebarItemsParams = {
  items: TNavItem[];
  pathname: string;
  level?: number;
};

type ReduceChildParams = {
  array: ReactNode[];
  item: TNavItem;
  pathname: string;
  level: number;
};

function renderSidebarItems({
                              items,
                              pathname,
                              level = 0
                            }: RenderSidebarItemsParams) {
  return (
    <List disablePadding>
      {items.reduce<ReactNode[]>(
        (array, item) => reduceChild({ array, item, pathname, level }),
        []
      )}
    </List>
  );
}

function reduceChild({ array, item, pathname, level }: ReduceChildParams) {
  const key = item.href + level;
  // if (item.items) {
  //   const match = matchPath(pathname, {
  //     path: item.href,
  //     exact: false
  //   });
  //
  //   return [
  //     ...array,
  //     <SidebarItem
  //       key={key}
  //       level={level}
  //       icon={item.icon}
  //       info={item.info}
  //       href={item.href}
  //       title={item.title}
  //       open={Boolean(match)}
  //     >
  //       {/* {renderSidebarItems({ */}
  //       {/*  pathname, */}
  //       {/*  level: level + 1, */}
  //       {/*  items: item.items */}
  //       {/* })} */}
  //     </SidebarItem>
  //   ];
  // }
  return [
    ...array,
    <SidebarItem
      key={key}
      level={level}
      href={item.href}
      icon={item.icon}
      info={item.info}
      title={item.title}
    />
  ];
}

type CustomLeftBarProps = {
  header: TNav;
};

// -----------------------------------------------------
export default function CustomLeftBar({ header }: CustomLeftBarProps) {
  const { translate } = useLocales();
  const { pathname } = useLocation();
  const { user } = useAuth();
  const { featuresPayload, featuresError, featuresLoading } = useSelector(
    (state: RootState) => state.features
  );

  function translateConverter(menulist: TNavItem[]) {
    menulist.map((p) => {
      p.title = translate(p.title);
    });
  }

  function filterAuth(items: TNavItem[]) {
    if (
      user.roles.includes(Roles.ADMIN) // && !user.roles.includes(Roles.SUPERADMIN)
    ) {
      return items.filter(
        (item) => item.role === Roles.ADMIN || item.role?.includes(Roles.ADMIN)
      );
    }
    if (user.roles.includes(Roles.SUPERADMIN)) {
      return items.filter(
        (item) =>
          item.role === Roles.SUPERADMIN ||
          item.role?.includes(Roles.SUPERADMIN)
      );
    }
    if (user.roles.includes(Roles.FIRE_FIGHTER)) {
      return items.filter(
        (item) =>
          item.role === Roles.FIRE_FIGHTER ||
          item.role?.includes(Roles.FIRE_FIGHTER)
      );
    }
    if (user.roles.includes(Roles.SUPERVISOR)) {
      return items.filter(
        (item) =>
          item.role === Roles.SUPERVISOR ||
          item.role?.includes(Roles.SUPERVISOR)
      );
    }
    if (
      user.roles.includes(Roles.USER) || user.roles.includes(Roles.CLIENT_ADMIN) &&
      !user.roles.includes(Roles.ADMIN) &&
      !user.roles.includes(Roles.SUPERADMIN)
    ) {
      const feature_codes = featuresPayload?.map((f) => f.codeName);

      return items
        .filter(
          (item) => item.role === Roles.USER || item.role?.includes(Roles.USER) || item.role?.includes(Roles.CLIENT_ADMIN)
        )
        .filter((item) => {
          if (item.feature) {
            return feature_codes?.includes(item.feature);
          }
          return true;
        });
    }
    return items;
  }

  return (
    <>
      {!featuresLoading || !featuresError ? (
        <List
          disablePadding
          key={header.subheader}
          subheader={
            <ListSubheader
              disableSticky
              disableGutters
              sx={{
                mt: 3,
                mb: 2,
                pl: 5,
                color: 'text.primary',
                typography: 'overline'
              }}
            >
              {filterAuth(header.items).length !== 0 ? translate(header.subheader) : ''}
              {translateConverter(filterAuth(header.items))}
            </ListSubheader>
          }
        >
          {renderSidebarItems({
            items: filterAuth(header.items),
            pathname
          })}

          {/*
          // !HATA Buna benzer bi kod olacak,
            {list.code ? user.ownmodule.includes(list.code) &&
              renderSidebarItems({
              items: filterAuth(list.items),
              pathname
              })} :
              (renderSidebarItems({
                items: filterAuth(list.items),
                pathname
              })) */}
        </List>
      ) : (
        <></>
      )}
    </>
  );
}
